import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { updateBodyClass } from 'src/helpers';
import { SERVICEINIT_URL, SERVICEINIT_URL_ADDSI, BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

//Lazy Load
const ServiceInitAddContainer = lazy(() => import('src/ui/features/ServiceInit/containers/ServiceInitAddContainer'));
const ServiceInitLandingContainer = lazy(() => import('src/ui/features/ServiceInit/containers/ServiceInitLandingContainer'));

class ServiceInitRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.SERVICEINIT);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.SERVICEINIT);
  }

  render() {
    return (
      <Layout headerName={'Service Initiation'}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Switch>
            <Route
              path={SERVICEINIT_URL_ADDSI + '/:assigneeServicePlanGlobalId'}
              render={props => <ServiceInitAddContainer {...props} />}
            />
            <Route path={SERVICEINIT_URL_ADDSI} render={props => <ServiceInitAddContainer {...props} />} />
            <Route path={SERVICEINIT_URL} render={props => <ServiceInitLandingContainer {...props} />} />
          </Switch>
        </Suspense>
      </Layout>
    );
  }
}

export default ServiceInitRoot;



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/index.js